import { action, observable } from 'mobx';

import customFetch from '../../../utils/customFetch';

class DocAndConsStore {
  @observable loading = true;
  @observable loadingSearch = true;
  @observable loadingHistory = true;
  
  @observable picData = [];
  @observable data = null;
  @observable dataSearch = null;
  @observable dataFiles = null;
  @observable dataActionNotes = null;
  @observable dataStaffs = null;
  @observable dataExport = null;
  @observable dataUser = null;
  @observable dataHistory = null;

  @observable ActionRequired = false;

  @observable keyword = '';
  @observable keywordSearch = '';
  @observable filterRecruitment = 'All';
  @observable filterStatus = 'active';
  @observable filterPIC = '';
  @observable fromTo = '';
  @observable statusId = 0;
  @observable serviceGroupId = 'All';

  @observable sortKey = 'FirstName';
  @observable sortColumn = 'Name';
  @observable sortDirection = 'ascending';

  @observable curPage = 1;
  @observable numberPageSearch = 30;
  @observable totalPage = 0;
  @observable totalItems = 0;

  @observable open = false;
  @observable modalParams = {};

  @action setFieldsValue = data => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  };

  @action handleSort = ({ sortKey }, { column, direction }) => {
    this.sortColumn = column;
    this.sortDirection = direction;
    this.sortKey = sortKey;
    this.fetchMain();
  };

  @action fetchFiles = (setTotalPage = false) => {
    this.loading = true;
    customFetch('/MedicalDoctor/GetAll', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ActionType: 'NONE',
        CurPage: this.curPage,
        NumItemPerPage: this.pageSize,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
        SearchClaimantOnly: true,
        NextPicId: null,
        ActionRequired: false,
        UrgentReport: false,
      }),
    }).then(
      action(data => {
        this.dataFiles = data;
        // this.totalPage = setTotalPage ? data.sumPage : this.totalPage;
        this.loading = false;
      }),
    );
  };

  @action fetchSearch = () => {
    this.loadingSearch = true;
    customFetch('/MedicalDoctor/GetAll', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        keyword: this.keywordSearch,
        CurPage: 1,
        NumItemPerPage: this.numberPageSearch,
        Showing: this.filterStatus,
        IsSelectionList: true,
      }),
    }).then(
      action(data => {
        this.dataSearch = data;
        this.loadingSearch = false;
      }),
    );
  };

  @action fetchMain = (setTotalPage = false) => {
    this.loading = true;
    customFetch('/MedicalDoctor/GetForMainListing', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ActionType: 'NONE',
        Keyword: this.keyword,
        CurPage: this.curPage,
        NumItemPerPage: this.pageSize,
        SortBy: this.sortKey,
        SortDirection: this.sortDirection.replace('ending', '').toUpperCase(),
        SearchClaimantOnly: true,
        NextPicId: null,
        ActionRequired: this.ActionRequired,
        UrgentReport: false,
        ActionRequiredById: this.filterPIC,
        ShowingRecruitment: this.filterRecruitment,
        Showing: this.filterStatus,
      }),
    }).then(
      action(data => {
        this.fetchSearch();
        this.data = data;
        this.totalPage = setTotalPage ? data.sumPage : this.totalPage;
        this.totalItems = setTotalPage ? data.sumItem : this.totalItems;
        this.loading = false;
      }),
    );
  };

  @action fetchHistory = () => {
    this.loadingHistory = true;
    customFetch('/Manager/GetLoginHistory', {
      method: 'POST',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify({
        uId: this.modalParams.record.UserId,
        CurPage: this.curPage,
        NumItemPerPage: this.pageSize,
        SortBy: 'LoginDate',
        SortDirection: 'descending'.replace('ending', '').toUpperCase(),
      }),
    }).then(
      action(data => {
        this.dataHistory = data;
        this.loadingHistory = false;
      }),
    );
  };

  toggleModal = (isOpen, params = {}) => {
    return action(() => {
      this.open = isOpen;
      this.modalParams = params;
    });
  };

  serviceItemCreate = (service = {}) => {
    return action(() => {
      this.serviceItem = service;
    });
  };

  @action handleSearchChange = ({ target }) => {
    this.keyword = target.value;
  };
  @action handleSearchChangeClinic = ({ target }) => {
    this.keywordClinic = target.value;
  };

  @action refetch = (data, setTotalPage) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchMain(setTotalPage);
  };

  @action refetchSearch = (data = {}) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchSearch(true);
  };

  @action refetchStaffs = (data = {}) => {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    this.fetchStaffs();
  };

  @action resetStore = () => {
    this.keyword = '';
    this.filterRecruitment = 'All';
    this.filterStatus = 'All';
    this.sortColumn = 'Name';
    this.sortKey = 'FirstName';
    this.ActionRequired = false;
    this.keywordSearch = '';

    this.numberPageSearch = 30;
    this.curPage = 1;
    this.totalPage = 0;

    this.refetch({}, true);
  };

  @action resetSearch = () => {
    this.keywordSearch = '';
    this.numberPageSearch = 30;

    this.refetchSearch({});
  };

  @action fetchPIC = () => {
    this.loading = true;

    return customFetch('/MedicalDoctor/GetStaffAssign', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    }).then(
      action(res => {
        if (res.status === 'success') {
          this.picData = res.itemList;
          console.log("picData", this.picData);
        }
      }),
    );
  };
}

export default new DocAndConsStore();
